module.exports = __webpack_public_path__ + "static/floralbibmain-e2dc6e4f96da0ac057aaf867ef5cfa83.png";